/**
 * Battle.net gateways, as the main menu's gateway button and Select Gateway dialog list them.
 * The page's own realm is always first; a deployment may add more with `VITE_GATEWAYS` (JSON:
 * `[{ "name": "Europe", "url": "wss://eu.example/realm" }]`). The choice and each realm's name
 * (learned from its welcome) are remembered in this browser.
 */
import { RealmClient } from './realm';

export interface Gateway {
  name: string;
  url: string;
}

const PICK_KEY = 'd2web.gateway';
const NAMES_KEY = 'd2web.gatewayNames';

function names(): Record<string, string> {
  try {
    return JSON.parse(localStorage.getItem(NAMES_KEY) ?? '{}') as Record<string, string>;
  } catch {
    return {};
  }
}

export function gateways(): Gateway[] {
  const known = names();
  const own = RealmClient.defaultUrl();
  const list: Gateway[] = [{ name: known[own] ?? 'hoerl.org Realm', url: own }];
  const env = (import.meta as unknown as { env?: Record<string, string> }).env;
  try {
    for (const g of JSON.parse(env?.VITE_GATEWAYS ?? '[]') as Gateway[])
      if (g?.url && g.url !== own) list.push({ name: known[g.url] ?? g.name ?? g.url, url: g.url });
  } catch {
    // A malformed list leaves the page's own realm.
  }
  return list;
}

export function currentGateway(): Gateway {
  const list = gateways();
  return list.find((g) => g.url === localStorage.getItem(PICK_KEY)) ?? list[0];
}

export function selectGateway(g: Gateway): void {
  localStorage.setItem(PICK_KEY, g.url);
}

/** Remembers the name a realm gave itself, so the gateway button can show it next time. */
export function rememberGatewayName(url: string, name: string): void {
  if (!name) return;
  const n = names();
  n[url] = name;
  localStorage.setItem(NAMES_KEY, JSON.stringify(n));
}
